import { ConfigCmd, FilterMode, Item } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { RenderResult } from "../types.js"
import { clearCanvas, drawRotatedImage, getImage, getTinted, toImage } from "../util.js"

const glowPx = 5.8

const modeColors = new Map<FilterMode, string>()
	.set(FilterMode.ALLOW_ALL, "#00c000")
	.set(FilterMode.ALLOW_FILTER_ONLY, "#c08000")
	.set(FilterMode.BLOCK_ALL, "#c00000")
	.set(FilterMode.BLOCK_FILTER_ONLY, "#c0c000")

rendererResolvers.push(
	({ toRel, item, config }) => {
		if (item != Item.ITEM_HATCH && item != Item.ITEM_HATCH_STARTER)
			return undefined

		const filterMode = config.filterMode ?? ConfigCmd.defaults.filterMode

		return {
			discriminator: `${item.id}_${filterMode.enumValue}`,
			async render() {
				const canvas = createCanvas(0, 0)
				const ctx = canvas.getContext("2d")

				const imgLid = await getImage("item_hatch")
				const imgPatch = await getTinted(getImage("item_hatch_patch"), modeColors.get(filterMode))

				const width = imgLid.height

				clearCanvas(canvas, ctx, width, width)

				ctx.drawImage(imgLid, 0, 0)
				drawRotatedImage(ctx, imgLid, 180, width / 2, width / 2, width / 2, width / 2)

				ctx.drawImage(imgPatch, 0, 2)
				drawRotatedImage(ctx, imgPatch, 180, width / 2 + 5, width / 2, imgPatch.width / 2, imgPatch.height / 2)

				const results: RenderResult[] = [
					{ image: await toImage(canvas) }
				]

				if (item == Item.ITEM_HATCH_STARTER) {
					results.push({
						image: await getGlowImage(),
						textureSizeOff: toRel(glowPx * 2, glowPx * 2),
						texturePosOff: toRel(-glowPx, -glowPx)
					})
				}

				return results
			}
		}
	}
)

// extract the starter glow part and draw it after the hatch
// so the hatch image isn't bigger and doesn't result in a bad look when resized
async function getGlowImage() {
	const img = await getImage("item_hatch_starter")
	const canvas = createCanvas(img.height, img.height)
	const ctx = canvas.getContext("2d")
	ctx.drawImage(img, 0, 0)
	drawRotatedImage(ctx, img, 180, canvas.width / 2 + 5, img.height / 2, img.width / 2, img.height / 2)
	ctx.clearRect(glowPx, glowPx, canvas.width - glowPx * 2, canvas.height - glowPx * 2)
	return toImage(canvas)
}
